import React, { useEffect, useState } from "react";

import Sidebar from "../components/Sidebar/Sidebar";
import * as FaIcons from "react-icons/fa";
import { Button } from "react-bootstrap";

import { useClient } from "../hooks/useClient";
import DynamicTable from "../components/Table/dynamic-table";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { IClient } from "../interfaces/client";
import { FormClient } from "../components/Forms/Form-Client";

export const FaEllipsisVIcon = FaIcons.FaEllipsisV as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaEditIcon = FaIcons.FaEdit as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaTrashIcon = FaIcons.FaTrash as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

const ClientPage: React.FC = () => {
  const [hash, setHash] = useState<string>(window.location.hash);
  const [editingClient, setEditingClient] = useState<IClient | null>(null);

  const { isLoading, Client, totalPages, pageNumber, setPageNumber } =
    useClient();

  const passengersColumns = [
    { key: "corporateName", label: "Cliente" },
    { key: "email", label: "E-mail" },
    { key: "cnpj", label: "CNPJ" },
    { key: "telephone", label: "Telefone" },
  ];

  const getPageFromHash = () => {
    const hash = window.location.hash;
    const match = hash.match(/page=(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  };

  const updatePage = (newPage: number) => {
    window.location.hash = `page=${newPage}`;
    setPageNumber(newPage);
  };

  useEffect(() => {
    const currentHash = window.location.hash;

    const onHashChange = () => {
      setPageNumber(getPageFromHash());
    };

    if (currentHash.startsWith("#page")) {
      window.addEventListener("hashchange", onHashChange);
      return () => window.removeEventListener("hashchange", onHashChange);
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    const handleHashChange = async () => {
      const currentHash = window.location.hash;
      if (currentHash.startsWith("#edit")) {
        const urlParams = new URLSearchParams(currentHash.split("?")[1]);
        const id = urlParams.get("id");
        if (id) {
          try {
            const data = Client.find((x) => x.id === Number(id));
            console.log("Client", Client);
            if (data) {
              console.log("data", data);
              setEditingClient(data);
            }
          } catch (error) {
            console.error("Erro ao buscar Venda:", error);
          }
        }
      } else {
        setEditingClient(null);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [Client]);

  return (
    <div
      className="d-flex"
      style={{ minHeight: "100vh", backgroundColor: "#000" }}
    >
      <Sidebar />
      <div
        className="flex-grow-1 p-4"
        style={{
          backgroundColor: "#ffffff",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
          padding: "32px",
          boxShadow: "0 0 12px rgba(0,0,0,0.05)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1
            style={{
              color: "#78E01D",
              fontWeight: "600",
              fontSize: "36px",
              marginBottom: "24px",
            }}
          >
            Clientes
          </h1>
          <Button
            type="button"
            onClick={() => {
              if (hash.startsWith("#add") || hash.startsWith("#edit")) {
                window.location.hash = "";
              } else {
                window.location.hash = "#add";
              }
            }}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              marginTop: "10px",
            }}
          >
            {hash.startsWith("#add") || hash.startsWith("#edit")
              ? "Voltar"
              : "+ Adicionar"}
          </Button>
        </div>

        {hash === "#add" && <FormClient />}
        {hash.startsWith("#edit") && (
          <FormClient Client={editingClient ?? undefined} />
        )}

        {!(hash.startsWith("#add") || hash.startsWith("#edit")) && (
          <DynamicTable
            isLoading={isLoading}
            emptyMessage="Nenhum dado encontrado."
            data={Client}
            columns={passengersColumns}
            page={pageNumber}
            setPage={updatePage}
            total={totalPages}
            actions={(row: any) => (
              <>
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button
                      aria-label="Ações"
                      style={{
                        marginLeft: "0.5rem",
                        padding: "0.5rem",
                        backgroundColor: "#f3f4f6",
                        borderRadius: "0.375rem",
                        transition: "background-color 0.2s",
                        outline: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#e5e7eb")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f3f4f6")
                      }
                    >
                      <FaEllipsisVIcon />
                    </button>
                  </DropdownMenu.Trigger>
                  <DropdownMenu.Content
                    sideOffset={4}
                    align="end"
                    style={{
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                      width: "10rem",
                      border: "1px solid #e5e7eb",
                      zIndex: 1000,
                    }}
                  >
                    <DropdownMenu.Item asChild>
                      <div
                        role="menuitem"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.5rem 0.75rem",
                          color: "#374151",
                          cursor: "pointer",
                          outline: "none",
                          backgroundColor: "transparent",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f3f4f6")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                        onClick={() =>
                          (window.location.hash = `#edit?id=${row.id}`)
                        }
                      >
                        <FaEditIcon style={{ marginRight: "0.5rem" }} />
                        Editar
                      </div>
                    </DropdownMenu.Item>
                    {/* <DropdownMenu.Item asChild>
                      <div
                        role="menuitem"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.5rem 0.75rem",
                          color: "#374151",
                          cursor: "pointer",
                          outline: "none",
                          backgroundColor: "transparent",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f3f4f6")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                        onClick={() =>
                          (window.location.hash = `#edit?id=${row.id}`)
                        }
                      >
                        <FaTrashIcon style={{ marginRight: "0.5rem" }} />
                        Excluir
                      </div>
                    </DropdownMenu.Item> */}
                  </DropdownMenu.Content>
                </DropdownMenu.Root>
              </>
            )}
          />
        )}
      </div>
    </div>
  );
};

export default ClientPage;
